
class PdpUtils {
  static insertOrPlayYtVideo(container) {
    if (container) {
      const loaded = container.dataset.loaded;
      if (loaded === 'false') {
        const url = container.dataset.url;
        if (url) {
          const iframe = document.createElement('iframe');
          iframe.src = url;
          iframe.width = "100%";
          iframe.height = "100%";
          iframe.frameBorder = "0";
          iframe.allow = "autoplay; encrypted-media; picture-in-picture";
          iframe.allowFullscreen = true;
          iframe.id = `yt-player-${Date.now()}`;
          container.appendChild(iframe);
        }
        container.dataset.loaded = 'true';
      } else {
        const iframe = container.querySelector("iframe");
        if (iframe && iframe.contentWindow) {
          iframe.contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', '*');
        }
      }
    }
  }

  static pauseYtVideo(container) {
    if (container) {
      const loaded = container.dataset.loaded;
      if (loaded === 'true') {
        const iframe = container.querySelector("iframe");
        if (iframe && iframe.contentWindow) {
          iframe.contentWindow.postMessage(
              '{"event":"command","func":"pauseVideo","args":""}',
              '*'
          );
        }
      }
    }
  }

  static pauseMyVideo(container) {
    if (container) {
      const loaded = container.dataset.loaded;
      if (loaded === 'true') {
        const video = container.querySelector("video");
        if (video) {
          video.pause();
        }
      }
    }
  }
  static insertOrPlayMyVideo(container) {
    if (container) {
      const loaded = container.dataset.loaded;
      if (loaded === 'false') {
        const videoTag = container.dataset.videoTag;
        if (videoTag) {
          container.innerHTML = videoTag;
        }
        container.dataset.loaded = 'true';
      } else {
        const video = container.querySelector("video");
        if (video) {
          video.play();
        }
      }
    }
  }
  static playMyVideo(video) {
    console.log(video);
  }

  static showThumbnailsByAltText(thumbnailNodes, altText) {
    const text = altText.toLowerCase();
    thumbnailNodes.forEach((node) => {
      let shouldHide = true;
      let nodeAlt = node.dataset.alt;
      if (nodeAlt !== undefined) {
        nodeAlt = nodeAlt.toLowerCase();
        if (nodeAlt === 'all') {
          shouldHide = false;
        } else {
          let tmp = nodeAlt.split(",");
          if (tmp.includes(text)) {
            shouldHide = false;
          }
        }
      }
      if (shouldHide) {
        node.classList.add("hidden");
      } else {
        node.classList.remove("hidden");
      }
    });
  }
}

class PdpThumbNails extends HTMLElement {
  thumbnailNodes;
  mainImageNodes;

  activeThumbnailClass = "active"; // This value should match what is being used in main-product.liquid

  constructor() {
    super();
    this.thumbnailNodes = this.querySelectorAll("li");

    this.thumbnailNodes.forEach((node) => {
      node.addEventListener("click", () => {
        this.toggleThumbnailClass(node.dataset.mediaId);
        this.setMainImageByMediaId(node.dataset.mediaId);
      });
    });
  }

  showThumbnailsByAltText(altText) {
    PdpUtils.showThumbnailsByAltText(this.thumbnailNodes, altText);
  }

  toggleThumbnailClass(mediaId) {
    const activeThumbnailClass = this.activeThumbnailClass;

    this.thumbnailNodes.forEach((node) => {
      if (node.dataset.mediaId.includes(mediaId)) {
        node.classList.add(activeThumbnailClass);
      } else {
        node.classList.remove(activeThumbnailClass);
      }
    });
  }

  setMainImageByMediaId(mediaId) {
    let mainImageNode;
    const mainImageNodes = this.getMainImageNodes();

    mainImageNodes.forEach((node) => {
      const media_type = node.dataset.mediaType;
      if (node.dataset.mediaId.includes(mediaId)) {
        node.classList.remove("hidden");
        node.classList.add("block");
        mainImageNode = node;

        if (media_type === 'youtube') {
          PdpUtils.insertOrPlayYtVideo(node.querySelector('.vid-container'));
        } else if (media_type === 'my_video') {
          PdpUtils.insertOrPlayMyVideo(node.querySelector('.vid-container'));
        }
      } else {
        node.classList.remove("block");
        node.classList.add("hidden");
        if (media_type === 'youtube') {
          PdpUtils.pauseYtVideo(node.querySelector('.vid-container'));
        } else if (media_type === 'my_video') {
          PdpUtils.pauseMyVideo(node.querySelector('.vid-container'));
        }
      }
    });

    return mainImageNode;
  }

  getMainImageNodes() {
    this.mainImageNodes =
      this.mainImageNodes || document.querySelectorAll("[data-main-image]");
    return this.mainImageNodes;
  }
}

customElements.define("pdp-thumbnails", PdpThumbNails);

class PdpThumbNailsMobile extends HTMLElement {
  thumbnailNodes;
  mainImageNodes;

  activeThumbnailClass = "active"; // This value should match what is being used in main-product.liquid

  constructor() {
    super();
    this.thumbnailNodes = this.querySelector('#pdp-tm-thumb').querySelectorAll("li");

    this.thumbnailNodes.forEach((node) => {
      node.addEventListener("click", () => {
        this.toggleThumbnailClass(node.dataset.mediaId);
        this.setMainImageByMediaId(node.dataset.mediaId);
      });
    });

    this.scrollDetection();

  }

  scrollDetection() {
    const slider = this.querySelector('#pdp-tm-main-image');
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          // Mark this element as the active target
          entry.target.classList.add('is-snapped');
        } else {
          entry.target.classList.remove('is-snapped');
        }
      });
    }, {
      root: slider,
      threshold: 0.6 // Adjust based on how much of the item must be visible to count as "snapped"
    });

    const items = slider.querySelectorAll("li");
    items.forEach(item => observer.observe(item));

// 2. Listen for the end of the snap animation
    slider.addEventListener('scrollend', () => {

      items.forEach((node) => {
        const media_type = node.dataset.mediaType;
        if (node.classList.contains('is-snapped')) {
          this.toggleThumbnailClass(node.dataset.mediaId);
          if (media_type === 'youtube') {
            PdpUtils.insertOrPlayYtVideo(node.querySelector('.vid-container'));
          } else if (media_type === 'my_video') {
            PdpUtils.insertOrPlayMyVideo(node.querySelector('.vid-container'));
          }
        } else {
          if (media_type === 'youtube') {
            PdpUtils.pauseYtVideo(node.querySelector('.vid-container'));
          } else if (media_type === 'my_video') {
            PdpUtils.pauseMyVideo(node.querySelector('.vid-container'));
          }
        }
      });

    });
  }

  showThumbnailsByAltText(altText) {
    PdpUtils.showThumbnailsByAltText(this.thumbnailNodes, altText);
  }

  toggleThumbnailClass(mediaId) {
    const activeThumbnailClass = this.activeThumbnailClass;

    this.thumbnailNodes.forEach((node) => {
      if (node.dataset.mediaId.includes(mediaId)) {
        node.classList.add(activeThumbnailClass);
      } else {
        node.classList.remove(activeThumbnailClass);
      }
    });
  }

  setMainImageByMediaId(mediaId) {
    let mainImageNode;
    const mainImageNodes = this.getMainImageNodes();

    for (const node of mainImageNodes) {
      const media_type = node.dataset.mediaType;
      const videoContainer = node.querySelector('.vid-container');
      if (node.dataset.mediaId.includes(mediaId)) {
        window.setTimeout(() => {
          // parent.scrollLeft = 0;
          node.scrollIntoView({
            block: "start",
            inline: "nearest",
            behavior: "smooth",
          });
        });
        if (media_type === 'youtube') {
          PdpUtils.insertOrPlayYtVideo(node.querySelector('.vid-container'));
        } else if (media_type === 'my_video') {
          PdpUtils.insertOrPlayMyVideo(node.querySelector('.vid-container'));
        }
      } else {
        if (media_type === 'youtube') {
          PdpUtils.pauseYtVideo(node.querySelector('.vid-container'));
        } else if (media_type === 'my_video') {
          PdpUtils.pauseMyVideo(node.querySelector('.vid-container'));
        }
      }
    }


  }

  getMainImageNodes() {
    this.mainImageNodes =
        this.mainImageNodes || document.querySelectorAll("[data-mobile-image]");
    return this.mainImageNodes;
  }
}

customElements.define("pdp-thumbnails-mobile", PdpThumbNailsMobile);
// Thumbnail video previews: attach the low-res source after page load, play only while on screen.
(function () {
  const start = () => {
    const vids = document.querySelectorAll('video.pdp-tb-video[data-preview-src]');
    if (!vids.length) return;
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const io = new IntersectionObserver((entries) => {
      entries.forEach(({ target: v, isIntersecting }) => {
        if (isIntersecting) {
          if (!v.src) v.src = v.dataset.previewSrc;
          const p = v.play();
          if (p && p.catch) p.catch(() => {});
        } else if (!v.paused) {
          v.pause();
        }
      });
    });
    vids.forEach((v) => { v.muted = true; if (!reduce) io.observe(v); });
  };
  if (document.readyState === 'complete') start();
  else window.addEventListener('load', () => setTimeout(start, 300));
})();

// Gallery videos play without controls; a tap/click shows them, and they hide again after 3s of no interaction.
(function () {
  const HIDE_MS = 3000;
  const hideLater = (v) => {
    clearTimeout(v._ctrlTimer);
    v._ctrlTimer = setTimeout(() => { v.controls = false; }, HIDE_MS);
  };
  let down = null;
  document.addEventListener('pointerdown', (e) => { down = { x: e.clientX, y: e.clientY }; }, true);
  document.addEventListener('pointerup', (e) => {
    const v = e.target.closest && e.target.closest('video.mobile-video');
    if (!v) return;
    // A swipe through the gallery is not a tap.
    if (down && Math.hypot(e.clientX - down.x, e.clientY - down.y) > 10) return;
    if (!v.controls) {
      v.controls = true;
      e.preventDefault();
    }
    hideLater(v);
  }, true);
  ['play', 'pause', 'seeking', 'volumechange'].forEach((ev) =>
    document.addEventListener(ev, (e) => {
      const v = e.target;
      if (v.matches && v.matches('video.mobile-video') && v.controls) hideLater(v);
    }, true)
  );
})();
